/**
 * Generate a URL-friendly slug from a title
 * @param title - The title to convert to a slug
 * @returns A URL-friendly slug
 */
export function generateSlug(title: string): string {
  // Convert to lowercase and replace spaces with hyphens
  let slug = title.toLowerCase();
  // Remove special characters and keep only alphanumeric, hyphens, and spaces
  slug = slug.replace(/[^a-z0-9\s-]/g, '');
  // Replace multiple spaces or hyphens with single hyphen
  slug = slug.replace(/[\s-]+/g, '-');
  // Remove leading/trailing hyphens
  slug = slug.replace(/^-+|-+$/g, '');
  return slug;
}

/**
 * Get the slug from a blog object, fallback to generated slug from title, then ID
 * @param blog - The blog object
 * @returns The slug to use for the URL
 */
export function getBlogSlug(blog: { slug?: string; title: string; id?: string }): string {
  return blog.slug || generateSlug(blog.title) || blog.id || '';
}
